import { SpecialCalculationCost } from '@/types/special-calculation-cost';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBreadcrumb, AppButton } from '../atoms';
import { AdminSpecialCalculationCostInfo } from '../organisms';

interface AdminSpecialCalculationCostDetailTemplateProps {
  breadcrumbItems: BreadcrumbItemType[];
  data: SpecialCalculationCost;
}

const AdminSpecialCalculationCostDetailTemplate = ({
  breadcrumbItems,
  data,
}: AdminSpecialCalculationCostDetailTemplateProps) => {
  const { id, site } = useParams<{ id: string; site: string }>();
  const currentSite = site ?? 'medix';
  const navigate = useNavigate();

  return (
    <section className="space-y-5 px-4">
      <AppBreadcrumb items={breadcrumbItems} paramsLabel="詳細" />
      <h3 className="text-xl">特殊医療助成金詳細: {id}</h3>
      <AdminSpecialCalculationCostInfo data={data} />
      <AppButton
        type="primary"
        onClick={() => navigate(`/${currentSite}/admin/special_calculation_costs`)}
      >
        前画面へ戻る
      </AppButton>
    </section>
  );
};

export default AdminSpecialCalculationCostDetailTemplate;
